import { useRouter } from 'next/router';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '@/containers/ConfigurePage/components/FormConfig/formData';
import { useData } from '@/lib/pageData/pageDataContext';
import {
  subscriptionCategories,
  SubscriptionType,
} from '@/utils/fetch/fetchProductSubscriptionByRegion';
import { formatPrice } from '@/utils/formatPrice';

export const useHeavyUserRate = (subscriptions: SubscriptionType[]) => {
  const { locale } = useRouter();
  const { currency } = useData<'default'>();
  const { watch } = useFormContext<FormValues>();

  const selectedDuration = watch('durationMonths');

  const heavyUseSubs = subscriptions.filter(
    sub =>
      sub.customerType === subscriptionCategories.heavyUse &&
      sub.minDurationMonths === +selectedDuration
  );
  const normalSubs = subscriptions.filter(
    sub =>
      sub.customerType === subscriptionCategories.normal &&
      sub.minDurationMonths === +selectedDuration
  );

  const normalSub = normalSubs.find(sub => sub.isSpecialOffer) ?? normalSubs[0];
  const heavyUseSub =
    heavyUseSubs.find(sub => sub.isSpecialOffer) ?? heavyUseSubs[0];

  const additionalAmount = (heavyUseSub.rate * 10 - normalSub.rate * 10) / 10;

  return {
    normal: formatPrice(
      heavyUseSub.rate,
      locale!,
      currency,
      heavyUseSub.rate % 1 !== 0
    ),
    additional: formatPrice(
      additionalAmount,
      locale!,
      currency,
      additionalAmount % 1 !== 0
    ),
  };
};
